/**
 * Zapiet Delivery Validator sets body padding-top from its topbar height, but
 * under-measures after our topbar restyles (and on wrapped mobile layouts).
 * Keep body padding in sync with the real fixed topbar height.
 */
(function () {
  const TOPBAR_SELECTOR = '#zapiet-delivery-validator__topbar';
  let resizeObserver = null;
  let observedEl = null;

  function topbarVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getBoundingClientRect().height > 0;
  }

  function syncBodyPadding() {
    const el = document.querySelector(TOPBAR_SELECTOR);
    if (!topbarVisible(el)) {
      if (document.body.style.paddingTop) {
        document.body.style.paddingTop = '';
      }
      return;
    }

    const height = Math.ceil(el.getBoundingClientRect().height);
    const next = height + 'px';
    if (document.body.style.paddingTop !== next) {
      document.body.style.paddingTop = next;
    }
  }

  function observeTopbar(el) {
    if (!el || el === observedEl) return;
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
    observedEl = el;
    resizeObserver = new ResizeObserver(syncBodyPadding);
    resizeObserver.observe(el);
    syncBodyPadding();
  }

  function boot() {
    const el = document.querySelector(TOPBAR_SELECTOR);
    if (el) observeTopbar(el);

    new MutationObserver(function () {
      const next = document.querySelector(TOPBAR_SELECTOR);
      if (next !== observedEl) {
        observeTopbar(next);
      }
      syncBodyPadding();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
